import { EComparisonAlbumsActionTypes } from './types';
import { type IComparisonAlbum } from '../../repositories/property-comparison/entities/v1_get_comparison_albums/ComparisonAlbum';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setComparisonAlbumsLoading = actionGenerator<EComparisonAlbumsActionTypes.Loading>(
  EComparisonAlbumsActionTypes.Loading,
);

export const setComparisonAlbumsSucceed = actionGenerator<EComparisonAlbumsActionTypes.Succeed, IComparisonAlbum[]>(
  EComparisonAlbumsActionTypes.Succeed,
);

export const setComparisonAlbumsFailed = actionGenerator<EComparisonAlbumsActionTypes.Failed>(
  EComparisonAlbumsActionTypes.Failed,
);
